import React from 'react';
import ColorInput from './ColorInput';

const families = [
    'system-ui', 'Inter, sans-serif', 'Roboto, sans-serif', 'Montserrat, sans-serif',
    'Georgia, serif', 'Times New Roman, serif', 'Courier New, monospace'
];

export default function FontsStyleEditor({ value, onChange, onSave }) {
    const t = value || {
        headers: { fontFamily: 'system-ui', fontSize: 28, fontWeight: 700, color: '#111111', lineHeight: 1.2 },
        paragraph: { fontFamily: 'system-ui', fontSize: 16, color: '#222222', lineHeight: 1.6 },
        links: { color: '#0ea5e9', textDecoration: 'underline' }
    };
    const patch = (scope, key, v) => onChange?.({
        ...t,
        [scope]: { ...(t[scope] || {}), [key]: v }
    });

    return (
        <div className="muulti-form" style={{ display:'grid', gap:12 }}>
            <h3>Headers</h3>
            <label>Font Family
                <select value={t.headers.fontFamily} onChange={e=>patch('headers','fontFamily', e.target.value)}>
                    {families.map(f=><option key={f} value={f}>{f}</option>)}
                </select>
            </label>
            <label>Size (px)
                <input type="number" min="10" max="96" value={t.headers.fontSize}
                       onChange={e=>patch('headers','fontSize', Number(e.target.value)||16)} />
            </label>
            <label>Weight
                <select value={t.headers.fontWeight}
                        onChange={e=>patch('headers','fontWeight', Number(e.target.value)||700)}>
                    {[400,500,600,700,800].map(w=><option key={w} value={w}>{w}</option>)}
                </select>
            </label>
            <label>Color
                <ColorInput value={t.headers.color} onChange={e=>patch('headers','color', e.target.value)} />
            </label>
            <label>Line Height
                <input type="number" min="1" step="0.05" value={t.headers.lineHeight}
                       onChange={e=>patch('headers','lineHeight', Number(e.target.value)||1.2)} />
            </label>

            <h3>Paragraph</h3>
            <label>Font Family
                <select value={t.paragraph.fontFamily} onChange={e=>patch('paragraph','fontFamily', e.target.value)}>
                    {families.map(f=><option key={f} value={f}>{f}</option>)}
                </select>
            </label>
            <label>Size (px)
                <input type="number" min="10" max="48" value={t.paragraph.fontSize}
                       onChange={e=>patch('paragraph','fontSize', Number(e.target.value)||16)} />
            </label>
            <label>Color
                <ColorInput value={t.paragraph.color} onChange={e=>patch('paragraph','color', e.target.value)} />
            </label>
            <label>Line Height
                <input type="number" min="1" step="0.05" value={t.paragraph.lineHeight}
                       onChange={e=>patch('paragraph','lineHeight', Number(e.target.value)||1.6)} />
            </label>

            <h3>Links</h3>
            <label>Color
                <ColorInput value={t.links.color} onChange={e=>patch('links','color', e.target.value)} />
            </label>
            <label>Decoration
                <select value={t.links.textDecoration}
                        onChange={e=>patch('links','textDecoration', e.target.value)}>
                    {['none','underline','overline','line-through'].map(d=><option key={d} value={d}>{d}</option>)}
                </select>
            </label>

            <div style={{ display:'flex', gap:8, marginTop:12 }}>
                <button className="muulti-button" onClick={()=>onSave?.(t)}>Save</button>
            </div>
        </div>
    );
}
